export default {
    SEARCH_PRODUCT: '[PRODUCT] SEARCH_PRODUCT',
    SEARCH_PRODUCT_RESULT: '[PRODUCT] SEARCH_PRODUCT_RESULT',
    RESET_PRODUCT_LIST: '[PRODUCT] RESET_PRODUCT_LIST',
    GET_LIST_PRODUCT: '[PRODUCT] GET_LIST_PRODUCT',
    GET_LIST_PRODUCT_RESULT: '[PRODUCT] GET_LIST_PRODUCT_RESULT',
    VIEW_PRODUCT: '[PRODUCT] VIEW_PRODUCT',
    SEARCH_BY_BARCODE: '[PRODUCT] SEARCH_BY_BARCODE',
    SYNC_ACTION_UPDATE_PRODUCT_DATA_FINISH: '[PRODUCT] SYNC_ACTION_UPDATE_PRODUCT_DATA_FINISH',
    SYNC_ACTION_DELETE_PRODUCT_DATA_FINISH: '[PRODUCT] SYNC_ACTION_DELETE_PRODUCT_DATA_FINISH',
    SYNC_ACTION_UPDATE_STOCK_DATA_FINISH: '[PRODUCT] SYNC_ACTION_UPDATE_STOCK_DATA_FINISH',
    SYNC_ACTION_UPDATE_CATALOG_RULE_PRICE_DATA_FINISH: '[PRODUCT] SYNC_ACTION_UPDATE_CATALOG_RULE_PRICE_DATA_FINISH',

    SYNC_ACTION_DELETED_CATALOG_RULE_PRICE_DATA_FINISH: '[PRODUCT] SYNC_ACTION_DELETED_CATALOG_RULE_PRICE_DATA_FINISH',

    CALCULATE_CHILD: 0,
    CALCULATE_PARENT: 1,
    SHIPMENT_SEPARATELY: 1,
    SHIPMENT_TOGETHER: 0,
}



// WEBPACK FOOTER //
// ./src/view/constant/ProductConstant.js